import { useCallback } from "react";
import { CertificateStatus, Organization } from "../types/certificate";

export const useCertificateStatus = () => {
  const getCertificateStatus = useCallback(
    (organization: Organization): CertificateStatus => {
      if (!organization.digital_certificate?.expiricy) {
        return { status: "Não possui", color: "default" };
      }

      const now = new Date();
      const expiry = new Date(organization.digital_certificate.expiricy);
      const daysUntilExpiry = Math.ceil(
        (expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
      );

      if (now > expiry) {
        return { status: "Vencido", color: "error" };
      } else if (daysUntilExpiry <= 30) {
        return { status: "À vencer", color: "warning" };
      } else {
        return { status: "Válido", color: "success" };
      }
    },
    [],
  );

  const getInvalidCertificateCountByProfile = useCallback(
    (organizations: Organization[], profile?: string): number => {
      return organizations.filter((org) => {
        if (profile && !org.profile?.includes(profile)) return false;
        if (!org.digital_certificate?.expiricy) return false;

        const now = new Date();
        const expiry = new Date(org.digital_certificate.expiricy);
        const daysUntilExpiry = Math.ceil(
          (expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
        );

        return now > expiry || daysUntilExpiry <= 30;
      }).length;
    },
    [],
  );

  const getNoCertificateCountByProfile = useCallback(
    (organizations: Organization[], profile?: string): number => {
      return organizations.filter((org) => {
        if (profile && !org.profile?.includes(profile)) return false;
        return !org.digital_certificate?.expiricy;
      }).length;
    },
    [],
  );

  const getValidCertificateCountByProfile = useCallback(
    (organizations: Organization[], profile?: string): number => {
      return organizations.filter((org) => {
        if (profile && !org.profile?.includes(profile)) return false;
        if (!org.digital_certificate?.expiricy) return false;

        const now = new Date();
        const expiry = new Date(org.digital_certificate.expiricy);
        const daysUntilExpiry = Math.ceil(
          (expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
        );

        return now <= expiry && daysUntilExpiry > 30;
      }).length;
    },
    [],
  );

  const getProfileName = useCallback((organization: Organization): string => {
    if (!organization.profile) return "-";

    if (organization.profile.includes("Empresas")) return "Empresas";
    if (organization.profile.includes("Igrejas")) return "Igrejas";
    if (organization.profile.includes("Terceiro Setor"))
      return "Terceiro Setor";
    if (organization.profile.includes("Save")) return "Save";
    if (organization.profile.includes("Persona")) return "Persona";
    if (organization.profile.includes("Interno")) return "Interno";

    return organization.profile;
  }, []);

  return {
    getCertificateStatus,
    getInvalidCertificateCountByProfile,
    getNoCertificateCountByProfile,
    getValidCertificateCountByProfile,
    getProfileName,
  };
};
